import classNames from 'classnames';
import HorizontalTileInner from './horizontal-tile-inner';
import PropTypes from 'prop-types';
import React from 'react';
import VerticleTileInner from './verticle-tile-inner';

const Tile = (props) => {
    const tileClass = classNames('tile', {
        'tile-verticle': !props.isSliderTile && !props.isHorizontal,
        'tile-slider': props.isSliderTile && !props.isHorizontal,
        'tile-horizontal': props.isHorizontal,
        'tile-page': props.type === 'page' && !props.isHorizontal,
        'has-presenter': props.company,
        'is-hero': props.isHero && props.isHorizontal
    });

    const renderTileInner = () => {
        if (props.isHorizontal) return <HorizontalTileInner {...props} />;

        return <VerticleTileInner {...props} />;
    };

    return (
        <div
            className={tileClass}
            aria-hidden={!props.isActive}
        >
            {renderTileInner()}
        </div>
    );
};

Tile.propTypes = {
    company:  PropTypes.string,
    isHero: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    isSliderTile: PropTypes.bool,
    type:  PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
};

Tile.defaultProps = {
    isHero: false,
    isHorizontal: false,
    isSliderTile: false,
    isActive: true,
};

export default Tile;
